const routes = [
    {
      path: '/student/studentvisualimpairments',
      name: 'StudentVisualImpairments',
      component: () => import('@/views/eden/studentVisualImpairments/Main.vue'),
    },
  ]
  
  export default routes
  